<template>
  <div class="open-mini-wrapper">
    <ElButton @click="openMini" type="primary" class="open-btn"> 打开小程序 </ElButton>
  </div>
</template>

<script>
import { goProctotingMini } from '@/utils/mini-scheme'
import { Button } from 'element-ui'
export default {
  components: {
    ElButton: Button
  },
  mounted() {
    goProctotingMini({ isDev: window.CONFIG.env !== 'production', examType: this.$route.query.examType, recordInterval: this.$route.query.recordInterval })
  },
  methods: {
    openMini() {
      goProctotingMini({ isDev: window.CONFIG.env !== 'production', examType: this.$route.query.examType, recordInterval: this.$route.query.recordInterval })
    }
  }
}
</script>
<style scoped>
  .open-mini-wrapper {
    width: 100vw;
    height: 100vh;
    position: relative;
  }
  .open-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>
